import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TabPanel, TabView } from "primereact/tabview";
import { useContext, useEffect, useRef, useState } from "react";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { Button } from "primereact/button";
import { AppDB } from "../../App";
import { helper } from "../../componets/utils/helper";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import VotersService from "../../services/VotersService";
import { APP_TYPE, formatDate } from "../../config/Config";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog"; // For <ConfirmDialog /> component
import EventService, { eventService } from "../../services/EventService";
import { Dropdown } from "primereact/dropdown";
import { UserDelimitation } from "../users/UserDelimitation";
import { delimitationService } from "../../services/DelimitationService";
import { InputTextarea } from "primereact/inputtextarea";
import LocalDelimitationNational from "../../componets/LocalDelimitationNational";
import { CandidateDBContext } from "./CandidateDBContext";
import { candidateService } from "../../services/CandidateService";
import { PrintOut } from "../reports/PrintOut";
import ScreenLoader from "../../componets/ScreenLoader";
import { reportService } from "../../services/ReportService";
import GenericUploadFileTable from "../../componets/GenericUploadFileTable";
import GenericFileCapture from "../../componets/GenericFileCapture";
import DocumentTypesService from "../../services/DocumentsService";
import MultiFilterSearch from "../../componets/MultiFilterSearch";
import { authenticationService } from "../../services/AuthenticationService";

export default function ({ header = null }) {
	var { selectedCanditate, isOnlyView } = useContext(CandidateDBContext);
	var political = new PoliticalPartyService();
	var [agentList, setAgentList] = useState([]);
	var [eventGroup, setEventGroup] = useState([]);
	var [event, setEvent] = useState([]);
	var [eventsMapping, setEventsMapping] = useState([]);
	var [loading, setLoading] = useState(false);
	var [refresh, setRefresh] = useState(false);
	var [isNational, setIsNational] = useState(false);
	var [votingStation, setVotingStation] = useState([]);
	const [delimitation, setDelimitation] = useState({ delimitationID: "", delimitationLevelID: "" });

	var [showFileUploader, setShowFileUploader] = useState(false);
	var [fileUploaderDocuments, setFileUploaderDocuments] = useState([]);
	var [loading, setLoading] = useState(false);
	var [agentDocumentTypes, setAgentDocuments] = useState([]);
	var isPoliticalParty = APP_TYPE == "PoliticalParty"
	var [showAddDialog, setShowAddDialog] = useState({
		show: false,
		voterRecord: null,
		idNumber: "",
		village: null,
		delimitationID: null,
		delimitationLevelID: null,
		event: null
	});
	var { toast, lookUp } = useContext(AppDB);

	var political = new PoliticalPartyService();
	var voter = new VotersService();
	var eventServices = new EventService();

	function flattenObjectOverride(obj) {
		const result = {};

		function recurse(current) {
			for (let key in current) {
				if (!current.hasOwnProperty(key)) continue;

				if (current[key] && typeof current[key] === 'object' && !Array.isArray(current[key])) {
					recurse(current[key]);
				} else {
					result[key] = current[key]; // override if key exists
				}
			}
		}

		recurse(obj);
		return result;
	}

	function portalUserDemarcation() {
		var obj = {
			districtId: null,
			constituencyId: null,
			pollingDivisionId: null,
			registrationCentreId: null,
			villageId: null
		};
		if (isPoliticalParty) {
			var userDelimitations = authenticationService.getUserDelimitation();

			if (userDelimitations.length > 0) {
				const { districtID, constituencyID, votingDistrictID } = userDelimitations[0];
				var _userIsNational = userDelimitations[0].isNationalDelimitation
				if (!_userIsNational) {
					obj.districtId = districtID;
					obj.constituencyId = constituencyID;
					obj.pollingDivisionId = votingDistrictID;
				}
			}
		}

		return obj;
	}

	useEffect(() => {
		//get event groups

		if (APP_TYPE !== "PoliticalParty") {
			eventService
				.getAllEvents({
					PageIndex: 1,
					PageSize: 100000,
					IsPoliticalPaty: true,
					ActiveOnly: true
				})
				.then((res) => {
					setEventsMapping(res);
					setLoading(false);
				});
		}
	}, [refresh]);

	var documentService = new DocumentTypesService();
	useEffect(() => {
		documentService.getDocumentTypes(3).then(res => {
			setAgentDocuments(res)
		})

	}, [])

	const [showReport, setshowReport] = useState(false);
	const handleDownloadReport = () => {
		var payload = {
			ReportID: 31,
			eventid: selectedCanditate?.eventID,
			delimitationID: showAddDialog.delimitationID,
			delimitationLevelID: showAddDialog.delimitationLevelID,
			CandidateID: selectedCanditate?.candidateID
		};
		getReport(payload);
	};

	const [base64, setBase64] = useState(null);
	const [fetchReportLoader, setfetchReportLoader] = useState(false);
	const [showReportDialog, setReportShowDialog] = useState(false);
	const getReport = (data) => {
		console.log("Report Parameters:", data);
		setfetchReportLoader(true);
		reportService
			.getReport(data)
			.then((response) => {
				setfetchReportLoader(false);

				if (response?.success) {
					setshowReport(true);
					setBase64(response.data);
					toast.show({ severity: "success", summary: "", detail: response.message, life: 3000 });
				} else {
					toast.show({ severity: "error", summary: "Message", detail: "No data found", life: 3000 });
				}
			})
			.catch((err) => {
				console.log(err);
				setfetchReportLoader(false);
				return toast.show({ severity: "error", summary: "Message", detail: "Something went wrong.", life: 3000 });
			});
	};
	useEffect(() => {
		setLoading(true);
		if (selectedCanditate !== null) {
			// selectedCanditate.eventID

			var obj = {
				delimitationID: showAddDialog?.delimitationID,
				delimitationLevelID: showAddDialog?.delimitationLevelID,
				candidateID: selectedCanditate.candidateID,
				eventID: selectedCanditate?.eventID
			}
			console.log(obj, delimitation)
			//get agent members
			candidateService
				.getCandidateAgentMembers(obj)
				.then((res) => {
					setAgentList(res.agents);
					//get event groups
					eventServices.getAllGroups().then((groups) => {
						setEventGroup(groups);
						setLoading(false);
						// setShowAddDialog({...showAddDialog,event:res})
					});
				});
		}
	}, [selectedCanditate, refresh, delimitation]);

	useEffect(() => {
		if (showAddDialog.eventGroupID !== null && showAddDialog.show === false) {
			setLoading(true);
			eventServices
				.getAllEvents({
					EventGroupID: showAddDialog.eventGroupID,
					PageIndex: 1,
					PageSize: 100000,
					IsPoliticalPaty: true,
					ActiveOnly: true
				})
				.then((_event) => {
					//get active event groups
					setEvent(_event);
					setLoading(false);
				});
		}
	}, [showAddDialog]);

	function searchVoterByIDNumber() {
		setLoading(true);
		voter.getByIDNumber(showAddDialog.idNumber).then((res) => {
			console.log(res);
			var status = `${res}`;

			if (res?.eligibleStatus === "N") {
				setLoading(false);
				toast.show({
					severity: "error",
					detail: "Elector not eligible",
					life: 2500
				});
				setShowAddDialog({
					...showAddDialog,
					village: null,
					voterRecord: null
				});
				return;
			}
			if (status.trim().length === 0) {
				setLoading(false);
				toast.show({
					severity: "error",
					detail: "Elector not Found",
					life: 2500
				});
				return;
			} else {
				if (selectedCanditate?.event?.isNationalDelimitation) {
					if (showAddDialog.delimitationID !== res.village.constituencyID) {
						toast.show({
							severity: "error",
							detail: "Elector must be in the same demarcation where the event is taking place",
							life: 5000
						});
						setLoading(false);
						setShowAddDialog({
							...showAddDialog,
							voterRecord: null,
							idNumber: "",
							village: null
						});
						return;
					}
				} else {
					if (showAddDialog.delimitationID !== res.village.councilID) {
						toast.show({
							severity: "error",
							detail: "Elector must be in the same demarcation where the event is taking place",
							life: 5000
						});
						setLoading(false);
						setShowAddDialog({
							...showAddDialog,
							voterRecord: null,
							idNumber: "",
							village: null
						});
						return;
					}
				}

				delimitationService.getRegistrationCentresByPollingDivision(res?.village?.pollingDivisionID).then((delim) => {
					setLoading(false);
					setVotingStation(delim);

					var contactNumber = "";

					res?.contactDetails.forEach((contact) => {
						if (contact?.contactType?.name === "Cellphone") {
							contactNumber = `${contact.countryCode.code}${contact.contactDetail}`;
							return;
						}
					});

					setShowAddDialog({
						...showAddDialog,
						village: res?.village,
						voterRecord: {
							contactNumber: contactNumber,
							firstname: res.firstname,
							surname: res.surname,
							dateOfBirth: res.dateOfBirth,
							gender: res.gender,
							voterID: res.voterID
						}
					});
				});
			}
		});
	}

	function searchVoterByFilter(idNumber) {
		setLoading(true);
		voter.getByIDNumber(idNumber).then((res) => {
			console.log(res);
			var status = `${res}`;

			if (res?.eligibleStatus === "N") {
				setLoading(false);
				toast.show({
					severity: "error",
					detail: "Elector not eligible",
					life: 2500
				});
				setShowAddDialog({
					...showAddDialog,
					village: null,
					voterRecord: null
				});
				return;
			}
			if (status.trim().length === 0) {
				setLoading(false);
				toast.show({
					severity: "error",
					detail: "Elector not Found",
					life: 2500
				});
				return;
			} else {
				if (selectedCanditate?.event?.isNationalDelimitation) {
					if (showAddDialog.delimitationID !== res.village.constituencyID) {
						toast.show({
							severity: "error",
							detail: "Elector must be in the same demarcation where the event is taking place",
							life: 5000
						});
						setLoading(false);
						setShowAddDialog({
							...showAddDialog,
							voterRecord: null,
							idNumber: "",
							village: null
						});
						return;
					}
				} else {
					if (showAddDialog.delimitationID !== res.village.councilID) {
						toast.show({
							severity: "error",
							detail: "Elector must be in the same demarcation where the event is taking place",
							life: 5000
						});
						setLoading(false);
						setShowAddDialog({
							...showAddDialog,
							voterRecord: null,
							idNumber: "",
							village: null
						});
						return;
					}
				}

				delimitationService.getRegistrationCentresByPollingDivision(res?.village?.pollingDivisionID).then((delim) => {
					setLoading(false);
					setVotingStation(delim);

					var contactNumber = "";

					res?.contactDetails.forEach((contact) => {
						if (contact?.contactType?.name === "Cellphone") {
							contactNumber = `${contact.countryCode.code}${contact.contactDetail}`;
							return;
						}
					});

					setShowAddDialog({
						...showAddDialog,
						village: res?.village,
						voterRecord: {
							contactNumber: contactNumber,
							firstname: res.firstname,
							surname: res.surname,
							dateOfBirth: res.dateOfBirth,
							gender: res.gender,
							voterID: res.voterID
						}
					});
				});
			}
		});
	}

	const handleAddAgent = async (event) => {
		setLoading(true);
		var docs = fileUploaderDocuments.map(doc => {
			var d = doc?.binaryData?.split(",");
			if (d?.length >= 2) {
				doc.binaryData = d[1];
			}
			return doc
		})
		candidateService
			.addCandidateAgentMember({
				candidateID: selectedCanditate.candidateID,
				voterID: showAddDialog.voterRecord.voterID,
				eventID: selectedCanditate.eventID,
				delimitationID: showAddDialog.delimitationID,
				delimitationLevelID: showAddDialog.delimitationLevelID,
				contactNumber: showAddDialog.voterRecord.contactNumber,
				physicalAddress: showAddDialog.voterRecord.physicalAddress,
				documents: docs
			})
			.then((res) => {
				setLoading(false);
				if (res.success) {
					setShowAddDialog({
						...showAddDialog,
						show: false,
						voterRecord: null,
						idNumber: "",
						village: null
					});
					setRefresh(!refresh);
					toast.show({
						severity: "success",
						detail: "Elector Added",
						life: 2500
					});
				} else {
					toast.show({
						severity: "error",
						detail: res.message,
						life: 2500
					});
				}
			});
	};

	const confirmDeleteAgent = (e, row) => {
		confirmDialog({
			target: e.currentTarget,
			message: "Are you sure you want to proceed?",
			icon: "pi pi-exclamation-triangle",
			accept: () => {
				setLoading(true);
				candidateService.deleteCandidateAgent(row).then((res) => {
					setLoading(false);
					if (res.success) {
						setRefresh(!refresh);
						toast.show({
							severity: "success",
							detail: "Agent Removed",
							life: 2500
						});
					} else {
						toast.show({
							severity: "error",
							detail: res.message,
							life: 2500
						});
					}
				});
			},
			reject: () => { }
		});
	};

	return (
		<>
			<ScreenLoader visible={fetchReportLoader} />
			<PrintOut base64={base64} setBase64={setBase64} showDialog={showReport} setShowDialog={setshowReport} />
			<ConfirmDialog />
			<div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
				{header !== null && <h5>{selectedCanditate?.eventName ? `${header} - ${selectedCanditate.eventName}` : header}</h5>}
			</div>
			<div className="card">
				<LocalDelimitationNational
					key={JSON.stringify(showAddDialog?.event)}
					showFilter={false}
					grid="3"
					level2Star={selectedCanditate?.event?.isNationalDelimitation ? "" : "*"}
					level3Star={selectedCanditate?.event?.isNationalDelimitation ? "" : "*"}
					level4Star={selectedCanditate?.event?.isNationalDelimitation ? "" : "*"}
					isNational={selectedCanditate?.event?.isNationalDelimitation}
					politicalDelimitation={{
						...selectedCanditate?.event,
						...portalUserDemarcation()
					}}
					// politicalDelimitation={selectedCanditate?.event}

					onChange={(delimitationID, delimitationLevelID, isLastLevel) => {
						// console.log(delimitationID, delimitationLevelID)
						setShowAddDialog({ ...showAddDialog, delimitationID: delimitationID, delimitationLevelID: delimitationLevelID });
						setDelimitation({ delimitationID: delimitationID, delimitationLevelID, delimitationLevelID: delimitationLevelID });
						console.log({ delimitationID: delimitationID, delimitationLevelID, delimitationLevelID: delimitationLevelID })
					}}
					onFilter={(e) => {
						// console.log({ ...e })
						// setDelimitation({ ...e });
					}}
				/>
				{!isOnlyView && (
					<div className="grid ">
						{/* <div className="md:col-3 col-12">
                            <Dropdown
                                className="w-full"
                                value={showAddDialog.event}
                                options={eventsMapping}
                                optionLabel="name"
                                onChange={(e) => {
                                    setShowAddDialog({ ...showAddDialog, event: e.value });
                                }}
                            />
                        </div> */}
						<div className="md:col-6 col-12">
							<Button
								disabled={[null, undefined, ""].includes(delimitation.delimitationID)}
								label="Add Agent"
								loading={loading}
								onClick={() => {
									setShowAddDialog({ ...showAddDialog, show: true });
								}}
								className="p-button-success mr-2"
							/>
							<Button
								disabled={selectedCanditate === null}
								label="Print"
								loading={loading}
								onClick={() => {
									console.log("Clicked");
									handleDownloadReport();
								}}
								className="p-button-primary"
							/>
						</div>
					</div>
				)}
			</div>

			<Dialog
				header={
					<>
						<h5 className="my-0">
							Add Agent - <small>{selectedCanditate?.event?.name}</small>
						</h5>
					</>
				}
				style={{ width: "100%", maxWidth: "1000px" }}
				onHide={() => {
					setShowAddDialog({
						...showAddDialog,
						show: false,
						voterRecord: null,
						idNumber: ""
					});
				}}
				visible={showAddDialog.show}
				footer={
					<>
						<Button disabled={showAddDialog.voterRecord === null} loading={loading} onClick={handleAddAgent} label="Submit" />
						<Button
							className="p-button-danger"
							onClick={() =>
								setShowAddDialog({
									...showAddDialog,
									show: false,
									voterRecord: null,
									idNumber: ""
								})
							}
							label="Close"
						/>
					</>
				}
			>
				{/* <hr /> */}
				<div className="col-12 f-bold">
					<b>Search Elector</b>
				</div>
				<div className="col-12">
					<MultiFilterSearch
						label={<>Search By <span style={{ color: "red" }}>*</span></>}
						onClear={() => {
							setShowAddDialog({ ...showAddDialog, voterRecord: null, idNumber: "" });
						}}
						onChange={res => {
							searchVoterByFilter(res.idNumber)

							setShowAddDialog({ ...showAddDialog, idNumber: res.idNumber });

						}} />
				</div>
				{/* <div className=" flex my-2">
					<InputText
						maxLength={12}
						style={{ width: "100%" }}
						placeholder="National ID"
						value={showAddDialog.idNumber}
						onChange={(e) => {
							setShowAddDialog({ ...showAddDialog, idNumber: e.target.value.trim().toLowerCase() });
						}}
					/>
					<Button
						className="ml-2"
						loading={loading}
						disabled={showAddDialog.idNumber.length !== 12}
						label="Search"
						onClick={() => {
							searchVoterByIDNumber();
						}}
					/>
				</div> */}
				{showAddDialog.voterRecord !== null && (
					<>
						<hr></hr>

						<div className="grid">
							<div className="col-12  md:col-6 ">
								<b>Event</b>
								<div className=" p-inputtext p-component p-filled">{selectedCanditate.eventName}</div>
							</div>

							<div className="col-12  md:col-6">
								<b>First Name</b>
								<div className=" p-inputtext p-component p-filled">{showAddDialog.voterRecord.firstname}</div>
							</div>

							<div className="col-12  md:col-6 ">
								<b>Surname</b>
								<div className=" p-inputtext p-component p-filled">{showAddDialog.voterRecord.surname}</div>
							</div>

							<div className="col-12  md:col-6 ">
								<b>Date Of Birth</b>
								<div className=" p-inputtext p-component p-filled">{formatDate(showAddDialog.voterRecord.dateOfBirth)}</div>
							</div>

							<div className="col-12  md:col-6 ">
								<b>Contact Number</b>
								<InputText
									className="w-full"
									value={showAddDialog.voterRecord.contactNumber}
									onChange={(e) => {
										showAddDialog.voterRecord.contactNumber = e.target.value;
										setShowAddDialog({ ...showAddDialog });
									}}
								/>
							</div>

						</div>
						<hr></hr>
						<div className="col-12  md:col-12 ">
							<b>Physical Address</b>
							<InputTextarea
								onChange={(e) => {
									showAddDialog.voterRecord.physicalAddress = e.target.value;
									setShowAddDialog({ ...showAddDialog });
								}}
								className="w-full"
								value={showAddDialog.voterRecord.physicalAddress}
							/>
						</div>

						<div className="col-12">
							<GenericFileCapture
								dontClearDocuments={true}
								refresh={refresh} setRefresh={setRefresh}
								key={JSON.stringify(showAddDialog)}
								extraAttributes={{
									// "candidateID": selectedCanditate.candidateID,
									"eventAgentID": selectedCanditate?.event?.eventID,
								}}
								documentTypesLookUp={agentDocumentTypes} show={showFileUploader} setShow={setShowFileUploader}
								setDocuments={setFileUploaderDocuments}
								documents={fileUploaderDocuments}
							/>
							<GenericUploadFileTable
								header={<div className="col-12  lg:col-3 my-2">
									<label htmlFor="description">
										Upload Documents
									</label>
									<br />
									<>
										<Button
											label={"Upload"}
											onClick={() => setShowFileUploader(true)}
											className="p-button-success"
											icon={"pi pi-plus"}
										/>
									</>
								</div>}
								setDocuments={setFileUploaderDocuments}
								documents={fileUploaderDocuments}
							/>
						</div>
						{/* <div className="col-12">
                            <GenericFileCapture
                                dontClearDocuments={true}
                                refresh={refresh} setRefresh={setRefresh}
                                key={JSON.stringify(showAddDialog)}
                                extraAttributes={{
                                    // "candidateID": selectedCanditate.candidateID,
                                    // "eventID": showCandidateDialog?.event?.eventID
                                }}
                                documentTypesLookUp={lookUp?.documentTypes} show={showFileUploader} setShow={setShowFileUploader}
                                setDocuments={setFileUploaderDocuments}
                                documents={fileUploaderDocuments}
                            />
                            <GenericUploadFileTable
                                header={<div className="col-12  lg:col-3 my-2">
                                    <label htmlFor="description">
                                        Upload Documents
                                    </label>
                                    <br />
                                    <>
                                        <Button
                                            label={"Upload"}
                                            onClick={() => setShowFileUploader(true)}
                                            className="p-button-success"
                                            icon={"pi pi-plus"}
                                        />
                                    </>
                                </div>}
                                setDocuments={setFileUploaderDocuments}
                                documents={fileUploaderDocuments}
                            />
                        </div> */}
					</>
				)}
			</Dialog>

			<DataTable
				size="small"
				scrollable={true}
				scrollHeight="400px"
				value={agentList}
				dataKey="id"
				loading={loading}
				rowsPerPageOptions={[5, 10, 25]}
				className="datatable-responsive"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Members"
				emptyMessage="No members found."
				responsiveLayout="scroll"
				// selection={selectedMember}
				// onSelectionChange={(e) => setSelectedMember(e.value)}
				resizableColumns
				columnResizeMode="expand"
				// filters={filters}
				filterDisplay="Name"
				globalFilterFields={["Name"]}
			>
				<Column field="registrationNumber" header="Registration Number" sortable></Column>
				<Column field="firstname" header="Name" sortable></Column>
				<Column field="surname" header="Surname" sortable></Column>
				<Column field="delimitation" header="Demarcation" sortable></Column>
				<Column
					field="delimitationName"
					header="Demarcation Name"
					body={(e) => `${e.delimitationCode}-${e.delimitationName}`}
					sortable
				></Column>

				<Column
					field="actions"
					header="Actions"
					body={(e) => (
						<>
							<Button
								disabled={isOnlyView}
								onClick={(ee) => confirmDeleteAgent(ee, e)}
								style={{ textAlign: "center", width: "30px", height: "30px" }}
								icon={"pi pi-times"}
								className="p-button-danger p-button-rounded mr-2"
								tooltip="Click to delete"
							/>
						</>
					)}
				></Column>
			</DataTable>
		</>
	);
}
